import React, { useEffect, useState } from "react";
import ROW from "./ROW";
import { returnElement } from "../../../components/CustomHooks/CustomHooks";
import useRender from "../../../components/CustomHooks/useRender";

const RowWrapper = (props) => {
    // console.log("allRows", props)
    const [renderElem, updatedData, isEqual] = useRender(props?.data);
        if (updatedData && !isEqual)
        props.data = updatedData;
      console.log("renderElem row", renderElem, props?.data);
    const renderComponent = () => {
        // console.log("insideRenderComponent", props, returnDisplayCheck(props.data.children))
            if(props.data?.children)
                return returnElement(
                    {
                    isSubformInPage: props?.isSubformInPage || false,
                    containerId: props.containerId,
                    name:"columns",
                    elem_type:"ROW",
                    key: props.id,
                    row_id: props.id,
                    control_id: props.id,
                    previewmode: props.previewmode,
                    frameindex: props.data.frameIndex,
                    elementIndex: props.elementIndex,
                    sheetIndex: props.sheetIndex,
                    isSubForm: props?.isSubForm,
                    buttonId: props?.buttonId,
                    stepIndex: props?.stepIndex,
                    sheetIndex: props?.sheetIndex,
                    subStepIndex: props?.subStepIndex,
                    sheetElementIndex: props?.data?.sheetElementIndex,
                    sheetElementIndex: props.sheetElementIndex,
                    section_back_color: props.section_back_color,
                    ReadOnlyStyle: props.ReadOnlyStyle,
                    sectionStyle:props?.sectionStyle,
                    },
                    props.data.children,
                    "ELEMENTS"
                );
    };
    return(
        <ROW {...props} renderChild={renderComponent()}/>
    )
} 
export default RowWrapper;